import React from 'react';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CustButton = ({
  children,
  color = 'primary',
  variant = 'contained',
  size = 'medium',
  iconFont,
  icon,
  ...props
}) => {
  let startIcon = null;

  if (iconFont) {
    startIcon = <FontAwesomeIcon icon={iconFont} />;
  } else if (icon) {
    startIcon = React.createElement(icon);
  }

  return (
    <Button
      color={color}
      variant={variant}
      size={size}
      startIcon={startIcon}
      {...props}
    >
      {children}
    </Button>
  );
};

CustButton.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  iconFont: PropTypes.object,        // FontAwesome icon object like `faLink`
  icon: PropTypes.elementType,       // A React component like `HomeIcon`
};

export default CustButton;
